import dataService from "../../api";
import { startLoading, stopLoading, catchHandler } from "../../utils/helpers";

const state = {

};

const getters = {
};

const mutations = {  
};

const actions = {
    async getStatistic(_ , params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.dashboard.getStatistic(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
              // showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
   async geEmployeesByStatus(_ , params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.dashboard.geEmployeesByStatus(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
              // showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
   async getNominationEmployeesByYear(_ , params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.dashboard.getNominationEmployeesByYear(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
              // showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 
   async geEmployeesByContractTypes(_ , params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.dashboard.geEmployeesByContractTypes(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
              // showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.data);

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    }, 



};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
